import { Company, CompanyCard } from "@/components/CompanyCard";
import { EntityGrid } from "@/components/common/EntityGrid";
import { useTranslation } from "react-i18next";

interface CompaniesGridProps {
  companies: Company[];
  filteredCompanies: Company[];
  isLoading: boolean;
}

export const CompaniesGrid = ({ 
  companies, 
  filteredCompanies, 
  isLoading 
}: CompaniesGridProps) => {
  const { t } = useTranslation();
  return (
    <EntityGrid
      data={filteredCompanies}
      isLoading={isLoading}
      emptyMessage={t("companies.empty")}
      renderItem={(company) => (
        <CompanyCard key={company.id} company={company} />
      )}
    />
  );
};
